import { useRelationshipFilterSchema } from "shared/schemas/relationshipSchemas";

import FilterBuilder from "features/ui/Filters/FilterBuilder";
import { FilterGroupState } from "features/ui/Filters/FilterBuilder/types";
import { useFilterSortState } from "features/ui/Filters/hooks";
import { SchemaEntry } from "features/ui/MaterialTable";

import {
  encodeExistsFilterValue,
  getFilterGroupStateFromExistsFilterValue,
} from "./utils";

interface Props {
  fieldName: string;
  onChange: (values: string[]) => void;
  disabled?: boolean;
  currentFilterValues: string[];
  relationEndpoint: string;
  relationSchema?: SchemaEntry[];
  pageKey?: string;
}

const ExistsFilter = ({
  fieldName,
  onChange,
  currentFilterValues = [],
  relationEndpoint,
  relationSchema,
  disabled,
  pageKey = "",
}: Props) => {
  const existsPageKey = `${pageKey}-exists-${fieldName}`;
  const lookupSchema = useRelationshipFilterSchema(relationEndpoint);
  const schema = relationSchema ?? lookupSchema;

  const filteredSchema = schema.filter(
    ({ filter, hideFilter }) => filter && !hideFilter
  );

  const existsFilterSortState = useFilterSortState({
    pageKey: existsPageKey,
    defaultFilterValues: getFilterGroupStateFromExistsFilterValue(
      currentFilterValues[0] || "[]"
    ),
    disableUsingQuery: true,
    disableUsingLocalStorage: true,
    onlyAdvancedFilters: true,
    schemaAttributes: schema.map(({ accessor }) => accessor),
  });

  const onApplyFilters = (newFilterState: FilterGroupState) => {
    existsFilterSortState.updateFilters(newFilterState);
    onChange([encodeExistsFilterValue(newFilterState)]);
  };

  return (
    <div className="mt-2">
      <FilterBuilder
        filterBuilderState={existsFilterSortState.advancedFilters}
        filtersSchema={filteredSchema}
        onChange={onApplyFilters}
        inline
        embedded
        disabled={disabled}
      />
    </div>
  );
};

export default ExistsFilter;
